import type { FC } from 'react';
import { Button } from '@components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@components/ui/dropdown-menu';
import { ChevronDownIcon } from '@heroicons/react/solid';
import clsx from 'clsx';

import { CONTRACT_OPTIONS } from '../constants';
import { type ContractOption, ContractOptionId } from '../types';

interface CreateContractButtonProps {
  hasFinalisedContracts: boolean;
  onSelect: (option: ContractOption) => void;
}

export const CreateContractButton: FC<CreateContractButtonProps> = ({ hasFinalisedContracts, onSelect }) => {
  const options = CONTRACT_OPTIONS.map((option) => {
    if (hasFinalisedContracts || option.id === ContractOptionId.CONTRACT) {
      return { ...option, isDisabled: false };
    }

    return { ...option, isDisabled: true };
  });

  return (
    <div className="mt-[2px] inline-flex rounded-md shadow-xs">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="primary" className="relative gap-2 py-1 pr-4 pl-3 text-sm font-medium">
            <span className="ml-2.5 pr-2">Create New</span>
            <span className="sr-only">Select contract type</span>
            <div className="absolute top-0 right-9 h-full w-px bg-white" />
            <ChevronDownIcon className="ml-1 h-5 w-5 text-white" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="start" className="divide-info-200 w-72 divide-y rounded-md p-0 shadow-lg">
          {options.map((option) => {
            return (
              <DropdownMenuItem
                key={option.id}
                className="group focus:bg-primary-500 data-[highlighted]:bg-primary-500 cursor-pointer rounded-none p-4 focus:text-white data-[highlighted]:text-white"
                onClick={() => onSelect(option)}
                disabled={option.isDisabled}
              >
                <div className="flex w-full flex-col">
                  <div className="flex items-center justify-between">
                    <p className={clsx('font-normal')}>{option.title}</p>
                  </div>
                  <p className="text-info-500 group-focus:text-primary-200 group-data-[highlighted]:text-primary-200 mt-2">
                    {option.description}
                  </p>
                </div>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
